<template>
  <div>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modalCreate"
      title="NOVA EVOLUÇÃO"
    >
      <CreateEvolution
        v-on:success="paginate"
        :resident_id="resident_id"
        :type="type"
      />
    </b-modal>

    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modalDuplicate"
      title="DUPLICAR EVOLUÇÃO"
    >
      <DuplicateEvolution v-on:success="paginate" :evolution="evolution" />
    </b-modal>

    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modalComplement"
      title="COMPLEMENTAR EVOLUÇÃO"
    >
      <ComplementEvolution
        v-on:success="paginate"
        :evolution_id="evolution.id"
      />
    </b-modal>

    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modalFinish"
      title="FINALIZAR EVOLUÇÃO"
    >
      <FinishEvolution
        v-on:success="paginate"
        :evolution="evolution"
        :complement="complement"
      />
    </b-modal>

    <div class="row">
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pr-0 d-flex align-items-center"
      >
        <h1 class="title-pages">{{ title }}</h1>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pl-0 text-right pl-0"
      >
        <v-btn @click="$bvModal.show('filtro')" class="btn-filter m-1">
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR</v-btn
        >
        <v-btn
          @click="$bvModal.show('modalCreate')"
          class="btn-add m-1"
          v-if="permission('write', target)"
          ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn
        >
      </div>
    </div>
    <b-modal
      no-close-on-backdrop
      centered
      hide-header-close
      hide-footer
      id="filtro"
      title="FILTRAR"
    >
      <div class="row">
        <div class="col-xl-12 pt-0">
          <h6 class="worksansr upper-text">STATUS</h6>

          <select v-model="status" class="form-control">
            <option value="APAGADO">EVOLUÇÕES APAGADAS</option>
            <option value="FINALIZADO">EVOLUÇÕES FINALIZADAS</option>
            <option value="ABERTO">EVOLUÇÕES ABERTAS</option>
            <option value="ALL">TODAS</option>
          </select>
        </div>

        <div class="col-xl-12 pt-0">
          <h6 class="worksansr upper-text">Data de início cadastro</h6>
          <input v-model="start_date" type="date" class="form-control" />
        </div>

        <div class="col-xl-12 pt-0">
          <h6 class="worksansr upper-text">Data de término cadastro</h6>
          <input type="date" v-model="end_date" class="form-control" />
        </div>

        <div class="col-xl-12">
          <ErrorsMessages :errors="errors" />

          <b-button class="btn-cancel m-1" @click="$bvModal.hide('filtro')"
            >CANCELAR</b-button
          >
          <v-btn class="btn-filter-sidebar float-right" @click="handleFilter">
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
        </div>
      </div>
    </b-modal>

    <b-overlay :show="loading" opacity="0.99">
      <div class="v-clean p-5 text-center" v-show="evolutions.length == 0">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>

      <v-data-table
        v-show="evolutions.length > 0"
        :headers="headers"
        :items="evolutions"
        :search="search"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template v-slot:[`item.technical_user_name`]="{ item }">
          <span
            v-if="item.status == 1 && item.technical_responsible == 1"
            class="validated"
          >
            {{ item.user_name }}
          </span>
          <span
            v-if="item.status == 1 && item.technical_responsible == 0"
            class="not-validated"
          >
            Não validado
          </span>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <span
            :class="['', item.status == 1 ? 'text-success' : 'text-danger']"
          >
            {{ item.status == 1 ? "ATIVO" : "APAGADO" }}
          </span>

          <span
            v-if="item.evolution_has_attachment.total > 0"
            title="Possui anexo!"
          >
            <span class="fas fa-paperclip"></span>
          </span>
        </template>

        <template v-slot:[`item.finish`]="{ item }">
          <span v-if="item.finish == 1" class="validated">
            {{ item.finish_user_name ? item.finish_user_name : "Finalizado" }}
          </span>
          <span
            v-if="item.status == 1 && item.finish == 0"
            class="not-validated"
          >
            Não Finalizado
          </span>
        </template>

        <template v-slot:[`item.text`]="{ item }">
          <span class="">
            {{
              String(item.text).length > 25
                ? `${String(item.text).substring(0, 25)}...`
                : item.text
            }}
          </span>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:[`item.attachments`]="{ item }">
          <v-btn
            :class="[
              'btn-modern',
              item.evolution_has_attachment.total > 0
                ? 'btn-modern-add'
                : 'btn-modern-info',
            ]"
            x-small
            @click="handleModalAttachments(item.id)"
          >
            <i class="fas fa-folder mr-2"></i> ANEXOS
          </v-btn>

          <b-modal
            size="lg"
            no-close-on-backdrop
            hide-footer
            :id="`attachments_evolution_${item.id}`"
            title="ANEXOS"
          >
            <Attachments @action="paginate" :evolution_id="item.id" />
          </b-modal>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            class="btn-modern btn-modern-add"
            x-small
            @click="clickRowTable(item)"
            ><i class="fas fa-edit mr-2"></i> Detalhes</v-btn
          >

          <b-modal
            size="md"
            no-close-on-backdrop
            hide-footer
            :id="`evolution-${item.id}`"
            title="EVOLUÇÃO"
          >
            <div class="row">
              <div class="alert-badge alert-warning mx-auto">
                <i class="fas fa-notes-medical mr-2"></i>
                <span>
                  {{
                    item.finish == 0
                      ? "Evolução salva. Finalize em até 14h"
                      : "Evolução Finalizada."
                  }}
                </span>
              </div>

              <div class="col-md-12">
                <textarea
                  disabled
                  class="form-control"
                  :value="item.text"
                  rows="8"
                />
              </div>

              <div v-if="item.evolution_complement" class="col-md-12">
                <span> Complementos: </span>

                <div class="mb-2">
                  <textarea
                    disabled
                    class="form-control mr-1"
                    :value="item.evolution_complement"
                    rows="5"
                    max-rows="10"
                  />
                </div>
              </div>

              <div v-if="item.status == 0" class="col-md-12 pt-0 pb-0">
                <WarningMessage message="EVOLUÇÃO APAGADA!" />
              </div>

              <div class="col-md-12">
                <ErrorsMessages :errors="errors" />
              </div>

              <div class="col-md-12">
                <confirmation-dialog
                  v-if="item.status == 1 && permission('remove', target)"
                  message-title="EXCLUIR?"
                  message-body="Deseja realmente excluir?"
                  open-class="btn-modern btn-modern-delete m-1"
                  open-left-icon="fa-trash"
                  open-text="EXCLUIR"
                  @yes="deleteEvolution(item.id)"
                />

                <v-btn
                  v-if="permission('write', target)"
                  @click="duplicate(item)"
                  class="btn-modern btn-modern-save m-1"
                  ><i class="fas fa-copy mr-1 text-twenty"></i> DUPLICAR</v-btn
                >

                <v-btn
                  @click="print(item.id)"
                  class="btn-modern btn-modern-info m-1"
                  ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
                >

                <div v-if="item.finish == 0 && item.status == 1">
                  <v-btn
                    @click="handleComplement(item)"
                    class="btn-modern btn-modern-save m-1"
                    ><i class="fas fa-plus mr-2 text-twenty"></i
                    >COMPLEMENTAR</v-btn
                  >
                </div>

                <ButtonGenerateCertificate
                  v-if="item.data_base64"
                  :id="item.id"
                  :data_base64="item.data_base64"
                />

                <confirmation-dialog
                  certificate
                  validate
                  v-if="
                    item.status == 1 &&
                    item.technical_responsible == 0 &&
                    userIsTechnicalResponsible
                  "
                  header-class=""
                  message-title="VALIDAR EVOLUÇÃO"
                  message-body="Deseja realmente Validar essa evolução?"
                  open-class="btn-modern btn-modern-save"
                  open-left-icon="fas fa-check"
                  open-text="VALIDAR EVOLUÇÃO"
                  @yes="validateEvolution(item.id)"
                />

                <LinkVerLocalizacaoRegistro :item="item" />
              </div>

              <div
                v-if="item.finish == 0 && item.status == 1"
                class="col-md-12"
              >
                <v-btn
                  @click="finish({ item, complement: 1 })"
                  class="btn-modern btn-modern-save m-1"
                >
                  <i class="fas fa-check mr-1"></i>
                  COMPLEMENTAR E FINALIZAR
                </v-btn>

                <confirmation-dialog
                  message-title="FINALIZAR SEM COMPLEMENTO?"
                  :message-body="`Após finalizar, não será possível alterar. Confirmar?`"
                  open-class="btn-notcertified m-1"
                  open-left-icon="fa-check"
                  open-text="FINALIZAR SEM COMPLEMENTAR"
                  @yes="finishEvolution(item.id)"
                />
              </div>
            </div>
          </b-modal>
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";

import { formatDate } from "../../lib/format";

import permission from "../../lib/permission";

import CreateEvolution from "./Create";

import DuplicateEvolution from "./Duplicate";

import ComplementEvolution from "./Complement";

import FinishEvolution from "./Finish";

import Attachments from "./Attachments";

import ErrorsMessages from "../Components/ErrorsMessages";

import WarningMessage from "../Components/WarningMessage";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ButtonGenerateCertificate from "../Components/ButtonGenerateCertificate";

import LinkVerLocalizacaoRegistro from "../Components/LinkVerLocalizacaoRegistro";

import toast from "../../lib/ToastNotification";

import { userData } from "../../lib/functions";

import moment from "moment";

import BRyHUB from "../../lib/BRy/hub";

export default {
  name: "Evolution",

  components: {
    CreateEvolution,
    DuplicateEvolution,
    ComplementEvolution,
    FinishEvolution,
    Attachments,
    ErrorsMessages,
    WarningMessage,
    ConfirmationDialog,
    ButtonGenerateCertificate,
    LinkVerLocalizacaoRegistro,
  },

  props: {
    type: [String],

    target: [String],

    resident_id: [String, Number],

    title: [String, Number],
  },

  data() {
    return {
      userIsTechnicalResponsible: false,

      isActiveFilter: false,

      search: "",

      start_date: moment().subtract(365, "days").format("YYYY-MM-DD"),

      end_date: moment().format("YYYY-MM-DD"),

      status: "ALL",

      headers: [
        { text: "FINALIZADO", value: "finish", sortable: false },
        { text: "STATUS", value: "status", sortable: false },
        // { text: "TEXTO", value: "text", sortable: false },
        { text: "CRIADO POR", value: "user_name", sortable: false },
        { text: "DATA CADASTRO", value: "created_at", sortable: false },
        { text: "", value: "attachments", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],

      evolutions: [],

      evolution: {},

      errors: [],

      loading: false,

      loadingDelete: false,

      complement: 0,
    };
  },

  async created() {
    let { user } = userData();

    this.paginate();

    if (user.technical_responsible == 1) {
      this.getUserIsTechnicalResponsible();
    }

    if (permission("read", "technical_responsible")) {
      this.headers.unshift({
        text: "VALIDADO RES. TÉC.",
        value: "technical_user_name",
        sortable: false,
      });
    }
  },

  methods: {
    permission,
    formatDate,
    moment,

    async paginate() {
      try {
        this.$bvModal.hide("modalDuplicate");
        this.$bvModal.hide(`evolution-${this.evolution.id}`);
        this.loading = true;

        let { resident_id, type, status, start_date, end_date } = this;

        let params = {
          resident_id,
          type,
          status,
          start_date,
          end_date,
        };

        let response = await api.get("/rest-home/evolutions", {
          params,
        });

        let { error, errors, evolutions } = response.data;

        if (!error) {
          this.isActiveFilter = false;
          this.evolutions = evolutions;
          this.errors = [];
          this.$bvModal.hide("filtro");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getUserIsTechnicalResponsible() {
      try {
        this.loading = true;

        const type = `EVOLUCAO_${this.type}`;

        let params = { type };

        let response = await api.get("/technical-responsible/user", { params });

        let { userIsTechnicalResponsible } = response.data;

        this.userIsTechnicalResponsible = userIsTechnicalResponsible;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    async validateEvolution(id) {
      try {
        this.loading = true;

        let params = { id, table_name: "evolution" };

        let response = await api.put("/technical-responsible", params);

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.paginate();

          this.$bvModal.hide(`evolution-${id}`);

          await BRyHUB.authorize({ id, table: "evolution" });
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    async deleteEvolution(id) {
      try {
        this.loadingDelete = true;

        let params = { id };

        let response = await api.patch("/rest-home/evolution", params);

        let { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide(`evolution-${id}`);
          this.paginate();
        } else {
          this.errors = errors;
        }

        this.loadingDelete = false;
      } catch (error) {
        console.log(error);
      }
    },

    async finishEvolution(evolution_id) {
      try {
        this.loading = true;

        let params = { evolution_id, complement: 0 };

        const response = await api.post("/rest-home/evolution/finish", params);

        const { error, errors, message, id } = response.data;

        if (!error) {
          this.errors = [];

          toast(message, "success");

          this.paginate();

          await BRyHUB.authorize({ id, table: "evolution" });
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    duplicate(evolution) {
      this.evolution = evolution;
      this.$bvModal.show("modalDuplicate");
    },

    handleComplement(evolution) {
      this.evolution = evolution;
      this.$bvModal.show("modalComplement");
    },

    finish({ item, complement }) {
      this.evolution = item;
      this.complement = complement;

      this.$bvModal.show("modalFinish");
    },

    handleModalAttachments(id) {
      this.$bvModal.show(`attachments_evolution_${id}`);
    },

    clickRowTable({ id }) {
      this.errors = [];
      this.$bvModal.show(`evolution-${id}`);
    },

    handleFilter() {
      this.paginate();
    },

    print(id) {
      let route = this.$router.resolve({
        name: "print_evolution",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style scoped>
.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
}
</style>
